import { CommonModule } from "@angular/common";
import { Component, OnInit, HostListener, NO_ERRORS_SCHEMA } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { NavigationComponent } from "src/app/shared/header/navigation.component";
// import { SidebarComponent } from "src/app/shared/sidebar/sidebar.component";
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import {LoaderComponent} from '../../shared/loader/loader.component'
import {FooterComponent} from '../../shared/footer/footer.component'
import { AuthService } from "src/app/services/auth/auth.service";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { HeaderComponent } from "../header/header.component";
const MINUTES_UNITL_AUTO_LOGOUT = 10 
const CHECK_INTERVAL = 15000;
const STORE_KEY = 'lastAction';
@Component({
  selector: "app-full-layout",
  standalone: true,
  imports:[RouterModule, SidebarComponent,HeaderComponent, NavigationComponent,LoaderComponent, CommonModule, NgbCollapseModule,FooterComponent],
  templateUrl: "./full.component.html",
  schemas: [NO_ERRORS_SCHEMA],
  styleUrls: ["./full.component.scss"],
})
export class FullComponent implements OnInit {

  constructor(public router: Router,public authService: AuthService) {}
  public isCollapsed = false;
  public innerWidth: number = 0;
  public defaultSidebar: string = "";
  public showMobileMenu = false;
  public expandLogo = false;
  public sidebartype = "full";
isAuthenticated: boolean = false;
  Logo() {
    this.expandLogo = !this.expandLogo;
  }

  ngOnInit() {
    // if (this.router.url === "/") {
    //   this.router.navigate(["/dashboard"]);
    // }
    this.defaultSidebar = this.sidebartype;
    this.handleSidebar();
      this.check();
    this.initListener();
    this.initInterval();
     localStorage.setItem(STORE_KEY, Date.now().toString());

       // Subscribe to current user
    this.authService.currentUserSubject.subscribe(user => {
      this.isAuthenticated = !!user;
    
    });

  }
 isSidebarOpen = false; // initial state

 
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.sidebartype = this.isSidebarOpen ? 'full' : 'mini-sidebar';
  }
  @HostListener("window:resize", ["$event"])
  onResize() {
    this.handleSidebar();
  }
initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover', () => this.reset());
    document.body.addEventListener('mouseout', () => this.reset());
    document.body.addEventListener('keydown', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
    document.body.addEventListener('keypress', () => this.reset());
  }
  reset() {
    this.setLastAction(Date.now());
  }
 
  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }
   public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY) || '{}');
  }
  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }   
  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    if (isTimeout) {
      this.authService.logout()
    }
  }
  handleSidebar() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1170) {
      this.sidebartype = "full";
    } else {
      this.sidebartype = this.defaultSidebar;
    }
  }

  toggleSidebarType() {
    switch (this.sidebartype) {
      case "full":
        this.sidebartype = "mini-sidebar";
        break;

      case "mini-sidebar":
        this.sidebartype = "full";
        break;

      default:
    }
  }
}
